import { render, staticRenderFns } from "./home-legend.vue?vue&type=template&id=690c23ef&"
import script from "./home-legend.vue?vue&type=script&lang=js&"
export * from "./home-legend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports